import React, { useEffect, useState } from "react";
import { GiftIcon } from "@heroicons/react/24/solid";
import ApiCustom from "../../utils/ApiCustom";
import { formatCurrencyVND } from "../../utils/helps";

const ProductPreviewModal = ({ isOpen, onClose, productSlug }) => {
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (!isOpen || !productSlug) return;

    setLoading(true);
    ApiCustom.get(`/product-show/${productSlug}`)
      .then((res) => {
        setProduct(res.data?.data || null);
      })
      .catch((err) => {
        console.log(err);
        setProduct(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [isOpen, productSlug]);

  useEffect(() => {
    if (!isOpen) {
      setProduct(null);
      setLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1000] bg-gray-500 bg-opacity-50 flex justify-center items-center p-4">
      <div className="bg-base-100 pb-0 rounded-lg w-11/12 max-w-6xl max-h-[90vh] overflow-y-auto">
        <div className="w-full">
          <div className="flex sticky top-0 bg-base-100 z-10 justify-between px-6 py-4 items-center border-b">
            <h2 className="text-2xl font-bold">Xem trước sản phẩm</h2>
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded-md shadow-sm text-sm font-medium text-base-700 bg-base-100 hover:bg-base-200"
            >
              X
            </button>
          </div>

          <div className="p-4 md:p-6">
            {loading ? (
              <div className="flex justify-center items-center min-h-[240px]">
                <div className="text-center text-lg font-semibold">
                  Loading...
                </div>
              </div>
            ) : !product ? (
              <div className="flex justify-center items-center min-h-[240px]">
                <div className="text-center text-lg font-semibold">
                  Sản phẩm không tồn tại!
                </div>
              </div>
            ) : (
              <>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-4 mb-4">
                  <div className="col-span-1 border w-full aspect-[5/4] border-gray-300 rounded-lg overflow-hidden">
                    <img
                      src={product.urlImage}
                      alt="Product Image"
                      className="w-full h-full object-cover rounded-lg shadow-md"
                    />
                  </div>

                  <div className="col-span-2 gap-4 border border-gray-300 rounded-lg p-4">
                    <h1 className="text-3xl font-bold">{product.name}</h1>

                    <div className="flex items-center mt-4">
                      <label className="mr-2 font-medium whitespace-nowrap">
                        Đơn vị cung cấp:
                      </label>
                      <p>{product.company?.companyName}</p>
                    </div>

                    <div className="flex items-center mt-4">
                      <label className="mr-2 font-medium">
                        Danh mục hàng hóa:
                      </label>
                      <p>{product?.category?.name}</p>
                    </div>

                    <div className="flex items-center mt-4">
                      <label className="mr-2 font-medium">Giá:</label>
                      {product.isContactPrice === true ? (
                        <div className="flex items-center justify-start gap-4">
                          <p className="text-xl leading-tight font-semibold text-red-500">
                            Liên hệ để biết thêm chi tiết
                          </p>
                        </div>
                      ) : product.discountPrice &&
                        Number(product.discountPrice) !== 0 ? (
                        <div className="flex items-center justify-start gap-4 flex-wrap">
                          <p className="text-xl font-semibold text-gray-500 line-through">
                            {formatCurrencyVND(product.price)}
                          </p>
                          <p className="text-2xl font-semibold text-red-500">
                            {formatCurrencyVND(Number(product.discountPrice))}
                            {" / " + product.unit}
                          </p>
                        </div>
                      ) : (
                        <div className="flex items-center justify-start gap-4">
                          <p className="text-2xl font-semibold text-red-500">
                            {formatCurrencyVND(product.price)}
                            {" / " + product.unit}
                          </p>
                        </div>
                      )}
                    </div>

                    {product.gift && product.giftCondition && (
                      <div className="flex items-center mt-4">
                        <GiftIcon className="w-5 h-5 animate-rgb-glow mr-2" />
                        <label className="font-medium">
                          {product.gift} khi tổng giá trị sản phẩm đạt{" "}
                          {formatCurrencyVND(product.giftCondition)}
                        </label>
                      </div>
                    )}
                  </div>
                </div>

                <div className="gap-4 border border-gray-300 rounded-lg p-4">
                  <h2 className="text-xl font-bold mb-4">Mô tả sản phẩm</h2>

                  <div className="flow-root">
                    <div className="sun-editor-editable">
                      <div
                        className="prose max-w-none"
                        dangerouslySetInnerHTML={{
                          __html: product?.description || "Không có mô tả.",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductPreviewModal;
